<template>
  <div calss="main-companys primary-bg">
    <div class="container">
      <!-- <div class="sec-wrapper d-flex align-items-center mt-4">
        <h2 id="famous-companies" class="section-title">ماذا نقدم</h2>
        <div class="blue-line"></div>
      </div> -->

      <!-- card for Certificates -->
      <b-container>
        <b-row class="my-5">
          <b-col
            class="col-lg-3 col-md-3 col-sm-6"
            v-for="certificate in certificateData.slice(0, 4)"
            :key="certificate.id"
          >
            <router-link
              :to="`/cerificate/${certificate.id}`"
              class="card block"
            >
              <img
                class="w-full h-100 object-cover"
                :src="certificate.file.url"
                :alt="certificate.type"
              />
            </router-link>
          </b-col>
        </b-row>

        <b-row class="my-5 align-items-center">
     
          <b-col
            class="col-lg-4 col-md-3 col-sm-6"
            v-for="certificate in certificateData.slice(4, 5)"
            :key="certificate.id"
          >
            <router-link
              :to="`/cerificate/${certificate.id}`"
              class="card block"
            >
              <img
                class="w-full h-100 object-cover"
                :src="certificate.file.url"
                :alt="certificate.type"
              />
            </router-link>
          </b-col>

          <b-col class="col-lg-4 col-md-3 col-sm-6">
            <router-link
              :to="`/Training`"
              class="card block"
              style="height: 240px"
            >
              <img
                class="w-full h-100 object-cover"
                src="@/assets/img/certificate/training.jpg"
                alt="go To Training"
              />
            </router-link>
          </b-col>

          <b-col
            class="col-lg-4 col-md-3 col-sm-6"
            v-for="certificate in certificateData.slice(5, 6)"
            :key="certificate.id"
          >
            <router-link
              :to="`/cerificate/${certificate.id}`"
              class="card block"
            >
              <img
                class="w-full h-100 object-cover"
                :src="certificate.file.url"
                :alt="certificate.type"
              />
            </router-link>
          </b-col>
       
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "companysArea",
  data() {
    return {
      activeTab: "all",
      certificateData: [],
      programsData: [],
      itemsPerPage: 2,
      currentPage: 1,
      totalPages: 5,
    };
  },
  computed: {
    companysTrainingsData() {
      return this.$store.state.companies.companysTrainingsPublicData;
    },
  },
  created() {
    this.$store.dispatch("companies/fetchCompanysTrainingsPublicData");
    this.fetchProgramsData();
    this.fetchcertificateData();
  },
  methods: {
    async fetchcertificateData() {
      try {
        const response = await axios.get(`/certificates`);
        this.certificateData = response.data.data.certificates;
      } catch (error) {
        console.error("Error fetching certificate data:", error);
      }
    },
    async fetchProgramsData() {
      try {
        const response = await axios.get(`/training_programs`);
        this.programsData = response.data.data.training_programs;
      } catch (error) {
        console.error("Error fetching training_programs data:", error);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped>
.card {
  background-color: #ffff;
  overflow: hidden;
  border-radius: 8px;
}
.card:hover {
  background-color: #fafafa;
  box-shadow: 0px 8px 12px 0px rgba(10, 10, 10, 0.4);
}
.h-100 {
  height: 100%;
}
.w-100 {
  width: 30px;
}
.title {
  color: #252c5d;
  font-weight: 600;
}
.sub-title {
  color: #234aa5;
  font-weight: 400;
}
</style>
